import { styleTokens } from "@ideally-ltd/design-tokens";
import { styled } from "@linaria/react";

const MatIcon = styled.i`
  text-align: center;
  vertical-align: middle;
  display: flex;
  align-items: center;
  font-weight: normal !important;
  font-style: normal !important;
  &.icon-sm.material-symbols-sharp {
    font-size: 0.75rem;
  }
  &.icon-normal.material-symbols-sharp {
    font-size: 1rem;
  }
  &.icon-lg.material-symbols-sharp {
    font-size: 1.25rem;
  }
  &.icon-xl.material-symbols-sharp {
    font-size: 2rem;
  }

  &.icon-success.material-symbols-sharp {
    color: ${styleTokens.button.success.background};
  }
  &.icon-contrast.material-symbols-sharp {
    color: ${styleTokens.button.contrast.color};
  }
  &.icon-danger.material-symbols-sharp {
    color: ${styleTokens["Ideally-Core"].scarlet[20]};
  }
`;

export const MatIconStyle = {
  MatIcon,
};
